import { loggerInit } from '@farmersdog/logger';

import config from '../../config';

export function initializeLogger() {
  const { level, ...datadog } = config.get('logger');
  // @ts-expect-error we can't type a convict variable using a datadog enum
  loggerInit({ level, datadog });
}
